import DAdminExitModal from '@d-shared/components/exit-modals/d-admin-exit-modal/d-admin-exit-modal.vue';
import DBlogOutScreen from '@d-components/d-blog-out-screen/d-blog-out-screen.vue';
import DDefaultExitModal from '@d-shared/components/exit-modals/d-default-exit-modal/d-default-exit-modal.vue';
import DSignupButton from '@d-shared/components/d-signup-button/d-signup-button.vue';
import DStickyMenu from '@d-components/d-sticky-menu/d-sticky-menu.vue';
import DTopMenuContainer from '@d-components/d-top-menu-container/d-top-menu-container.vue';
import DTrackingLink from '@d-shared/components/d-tracking-link/d-tracking-link.vue';

export default {
  DAdminExitModal,
  DBlogOutScreen,
  DDefaultExitModal,
  DSignupButton,
  DStickyMenu,
  DTopMenuContainer,
  DTrackingLink,
};
